import { render, staticRenderFns } from "./BikyConfigChatMessage.vue?vue&type=template&id=745d5d95&scoped=true&"
import script from "./BikyConfigChatMessage.vue?vue&type=script&lang=ts&"
export * from "./BikyConfigChatMessage.vue?vue&type=script&lang=ts&"
import style0 from "./BikyConfigChatMessage.vue?vue&type=style&index=0&id=745d5d95&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745d5d95",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
